export default __webpack_public_path__ + "static/media/pic.6c1cceb6.png";